var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.all_sections !== undefined &&
    !_vm.all_sections.sections_exclude.includes(_vm.section)
    ? _c(
        "li",
        {
          staticClass: "m-menu__item",
          class: [
            { "m-menu__item--submenu": _vm.submenu },
            { "m-menu__item--active": _vm.active },
            { "m-menu__item--open": _vm.openMenu }
          ],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-submenu-toggle": _vm.submenu ? "hover" : "toggle"
          }
        },
        [
          _vm.submenu
            ? _c(
                "a",
                {
                  staticClass: "m-menu__link m-menu__toggle",
                  attrs: { href: "" }
                },
                [
                  _c("i", {
                    staticClass: "m-menu__link-icon",
                    class: _vm.icon
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "m-menu__link-text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("titleize")(_vm._f("translate")(_vm.name))
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.submenu
                    ? _c("i", {
                        staticClass: "m-menu__ver-arrow la la-angle-right"
                      })
                    : _vm._e()
                ]
              )
            : _c(
                "router-link",
                {
                  staticClass: "m-menu__link m-menu__toggle",
                  attrs: { to: _vm.link }
                },
                [
                  _c("i", {
                    staticClass: "m-menu__link-icon",
                    class: _vm.icon
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "m-menu__link-text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("titleize")(_vm._f("translate")(_vm.name))
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.submenu
                    ? _c("i", {
                        staticClass: "m-menu__ver-arrow la la-angle-right"
                      })
                    : _vm._e()
                ]
              ),
          _vm._v(" "),
          _vm.submenu
            ? _c(
                "div",
                { staticClass: "m-menu__submenu", style: _vm.showSubmenu },
                [
                  _c("span", { staticClass: "m-menu__arrow" }),
                  _vm._v(" "),
                  _vm._t("submenu")
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48619302", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48619302","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/sidebar/Menu.vue
// module id = 567
// module chunks = 0 54 76 154